import { render, staticRenderFns } from "./yesInput.vue?vue&type=template&id=510d57ab"
import script from "./yesInput.vue?vue&type=script&lang=js"
export * from "./yesInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports